import { PictureIcon, ButtonIcon, Tooltip } from 'canoe';
import React from 'react';

import { useToggle } from 'commons/hooks';
import { MediaLibrary } from 'craft/components/MediaLibrary';
import { useMultiNodes, useSelection } from 'craft/hooks';

export const MediaLibraryButton = () => {
  const { selection } = useSelection();
  const [isModalOpen, toggleModal] = useToggle(false);

  const { collections } = useMultiNodes(selection.all, (node) => ({
    collections: node?.data.custom.collections,
  }));

  if (selection.isEmpty || selection.hasRootNode) {
    return null;
  }

  // If our nodes are using collections we don't have a media source popout
  if (collections?.length > 0) {
    return null;
  }

  return (
    <>
      <Tooltip placement="top" offset="xxs" content="Open Media Library">
        <ButtonIcon
          size="small"
          icon={PictureIcon}
          onClick={toggleModal}
          radius="small"
          color="white"
        />
      </Tooltip>
      <MediaLibrary
        nodeIds={selection.all}
        name="src"
        isModalOpen={isModalOpen}
        toggleModal={toggleModal}
      />
    </>
  );
};
